/* eslint-disable indent */
/* eslint-disable array-bracket-newline */
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import TableCardMobile from '../../../molecules/Table/mobile/TableCard';
import { toFixed4 } from '../formatters';
import { getVolume } from '../helpers';
import { formatPrice } from '../../Modal/TickersModal/helper';
import StatsMobile, { IStatsMobileProps } from '../mobile/Stats';
import Loader from '../../common/Loader';
import { ITopTradersSelector } from '.';

interface ITopTradersTableMobileProps extends ITopTradersSelector {
  loading: boolean;
  address: string | undefined;
  wallets: any[];
}

const getColorForItem = (row: any) => {
  if (row.buy_count > 0 && row.sell_count > 0) {
    return 'grey';
  }
  if (row.buy_count > 0) {
    return 'green';
  }
  return 'red';
};

const TopTradersTableMobile = ({
  wallets,
  loading,
  exchange,
  address,
  base_decimals,
  quote_decimals,
  base,
  quote,
  rates,
  flipped,
  chain,
}: ITopTradersTableMobileProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: '№',
        accessor: '№',
        parser: (_, __, index) => index!,
        width: 40,
      },
      item_2: {
        name: 'Avg Sell Price ($)',
        accessor: 'avg_usd_sell',
        parser: (value) => formatPrice(value),
        width: 95,
      },
      item_3: {
        name: 'Avg Buy Price ($)',
        accessor: 'avg_usd_buy',
        parser: (value) => formatPrice(value),
      },
    },
    row_2: {
      item_1: {
        name: 'Bot TX',
        accessor: 'bot_count',
        width: 40,
      },
      item_2: {
        name: 'Wallet',
        accessor: 'wallet',
        parser: (value) =>
          `${value.slice(0, 6)}...${value.slice(value.length - 4)}`,
        width: 95,
      },
      item_3: {
        name: 'Trading Volume ($)',
        accessor: 'volume_usd',
        parser: (value) => toFixed4(value),
      },
    },
  };

  const renderFooter = (props: any) => <StatsMobile {...props} />;

  const footerData: Omit<IStatsMobileProps, 'data' | 'actionShowModal'> = {
    quote_decimals,
    quote,
    address,
    chain,
    exchange,
    short: true,
  };

  const parsedData =
    !loading && wallets.length
      ? formatMobileTableData({
          data: wallets,
          schema,
          getColorForItem,
          renderFooter,
          footerData,
        })
      : undefined;

  return (
    <div className='dex_trades_mobile__table'>
      {loading ? (
        <div className='centrify'>
          <Loader />
        </div>
      ) : !wallets.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        parsedData?.map((row, index) => (
          <TableCardMobile key={index} data={row} />
        ))
      )}
    </div>
  );
};

export default TopTradersTableMobile;
